import { useState, useRef, useEffect, useCallback } from "react";
// import { useGetTitle } from "../../../hooks/useGetTitle";
import { useParams } from "react-router-dom";
//import { toast } from "react-toastify";

import { 
  Box, Breadcrumbs, Button, 
  Card, ClickAwayListener,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Tabs, Tab, Typography, TextField, Table, TableBody, TableCell, TableRow, TableContainer as MuiTableContainer,
  useTheme 
} from "@mui/material";

import styled from "styled-components";

import SearchIcon from "@mui/icons-material/Search"; // MUI의 검색 아이콘
import DownloadIcon from "@mui/icons-material/Download";

import { AgGridReact } from 'ag-grid-react';
import { AG_GRID_LOCALE_KR } from "@ag-grid-community/locale";
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Theming API 전용 스타일(ag grid v33 버전)
import customAgGridStyled from "./report-aggrid-override.css"; // 

import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

import { useProjectApi } from "../../../hooks/useProjectApi";

import { 
  useGetTableData, 
  useGetTableDataInQueryString 
} from "../../../components/Table/hooks";

import { axiosPrivate } from "../../../../../api/axios";

import { strategyRegisterColumns } from "../../../constants/columns";
import { TableTemplate } from "../../../components/Table/TableTemplate";
import { ModalTemplate } from "../../../components/Table/ModalTemplate";
import { 
  BreadcrumbsTable,
  CollapsibleCardTemplate
} from "../../../components/common/HelperFunc";
//import * as message from "../../../constants/messages";
import Buttons from "../../../../common/Buttons";
import { FONT_PROPS, COLORS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 32px 20px 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

//////////////////////////////////
// 위험성평가 보고서 컴포넌트
//////////////////////////////////
const PARENT_TITLE = "모니터링";
const CHILD_TITLE = "위험성평가 보고서";
export function MonitoringReport() {
  const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 탭 상태관리
  const [tabValue, setTabValue] = useState('one');
  const handleTabChange = (event, newValue) => setTabValue(newValue);

  ////////////////////////
  // 렌더링
  ////////////////////////
  function renderData() {
    return (
      <>
        {/* 탭 기능 */}
        <Box sx={{ display: 'flex', borderBottom: `1px solid ${theme.palette.divider}`, }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            sx={{
              borderBottom: 'none',
              marginLeft: '32px',
              '& .MuiTabs-indicator': {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <Tab value="one" label="★ 정기 보고서" 
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'one' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
            <Tab value="two" label="★ 개선실행 결과서"
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'two' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
          </Tabs>
        </Box>
        {/* 정기 보고서 */}
        {tabValue === 'one' && (
          <TableContainer>
            <RegularReport />
          </TableContainer>
        )}
        {/* 개선실행 결과서 */}
        {tabValue === 'two' && (
          <TableContainer>
            <StrategyReport />
          </TableContainer>
        )}
      </>
    );
  }

  // MonitoringReport 렌더링
  return (
    <Box sx={{ bgcolor: 'var(--mui-palette-background-paper)',height: '100%',display: 'flex',flexDirection: 'column'}}>
      {/* 브레드크럼 + 타이틀 */}
      <BreadcrumbsTable parentTitle={PARENT_TITLE} childTitle={CHILD_TITLE} useTab={true} />
      {/* 테이블 표시 */}
      {renderData()}
    </Box>
  );
}

/**
 * 정기 보고서 관련 객체 및 함수
 */

// AG Grid Colums 정의
const reportColumn = [
  {
    field: 'process_name',
    headerName: '평가 대상명',
    flex: 1,
    //headerClass: innerStyles.headerText, // 특정 칼럼에 css 적용 시 hearclass,cellclass 사용
    //cellClass: innerStyles.cellText,
    filter: true, // 필터 기능 활성화
  },
  {
    field: 'danger_category',
    headerName: '위험분류',
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'danger_description',
    headerName: '위험발생상황 및 결과',
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'machine_name',
    headerName: '설비·구역명',
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'prev_improve_plan',
    headerName: '이전 위험성 개선대책',
    valueFormatter: (params) => { // cell 데이터 변경
      const { prev_improve_plan } = params.data;

      return prev_improve_plan || '-';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'eval_scale',
    headerName: '평가 척도',
    valueFormatter: (params) => { // cell 데이터 변경
      return '5x4'; // 평가 척도는 고정값으로 설정
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'frequency_level',
    headerName: '가능성(빈도)',
    valueFormatter: (params) => { // cell 데이터 변경
      const { frequency_level } = params.data;
      const riskLevels = [
        { level: 1, name: '최하' },
        { level: 2, name: '하' },
        { level: 3, name: '중' },
        { level: 4, name: '상' },
        { level: 5, name: '최상' },
      ];
      // 표준 ID에 따라 위험성 레벨을 결정
      const frequencyLevel = riskLevels.find(r => r.level === frequency_level);
      const result = frequencyLevel ? `${frequencyLevel.level}(${frequencyLevel.name})` : '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'importancy_level',
    headerName: '중대성(강도)',
    valueFormatter: (params) => { // cell 데이터 변경
      const { importancy_level } = params.data;
      const riskLevels = [
        { level: 1, name: '소' },
        { level: 2, name: '중' },
        { level: 3, name: '대' },
        { level: 4, name: '최대' },
      ];
      // 표준 ID에 따라 위험성 레벨을 결정
      const importancyLevel = riskLevels.find(r => r.level === importancy_level);
      const result = importancyLevel ? `${importancyLevel.level}(${importancyLevel.name})` : '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'risk_level',
    headerName: '개선전 위험성',
    valueFormatter: (params) => { // cell 데이터 변경
      const { frequency_level, importancy_level, standard_id } = params.data;
      const riskLevels = [
        { level: 1, name: '매우 낮음' },
        { level: 2, name: '낮음' },
        { level: 3, name: '보통' },
        { level: 4, name: '약간 높음' },
        { level: 5, name: '높음' },
        { level: 6, name: '매우 높음' },
      ];
      // 표준 ID에 따라 위험성 레벨을 결정
      const riskLevel = riskLevels.find(r => r.level === standard_id);
      const riskPoint = frequency_level * importancy_level; // 위험성 포인트 계산
      const result = riskPoint ? `${riskPoint}(${riskLevel.name})` : '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'improve_plan',
    headerName: '위험성 개선대책',
    valueFormatter: (params) => { // cell 데이터 변경
      const { improve_plan } = params.data;
      const result = improve_plan || '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'improve_after_risk',
    headerName: '개선후 위험성',
    valueFormatter: (params) => { // cell 데이터 변경
      const { improve_after_risk } = params.data;
      const riskLevels = [
        { level: 1, name: '매우 낮음' },
        { level: 2, name: '낮음' },
        { level: 3, name: '보통' },
        { level: 4, name: '약간 높음' },
        { level: 5, name: '높음' },
        { level: 6, name: '매우 높음' },
      ];
      const riskLevel = riskLevels.find(r => r.level === improve_after_risk);
      const result = riskLevel ? riskLevel.name : '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'expected_date',
    headerName: '개선 예정일',
    valueFormatter: (params) => { // cell 데이터 변경
      const { expected_date } = params.data;
      const result = expected_date || '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'comp_date',
    headerName: '개선 완료일',
    valueFormatter: (params) => { // cell 데이터 변경
      const { comp_date } = params.data;
      const result = comp_date || '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'emp_name',
    headerName: '담당자',
    valueFormatter: (params) => { // cell 데이터 변경
      const { emp_name } = params.data;
      const result = emp_name || '-';
      return result || '알 수 없음';
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
  {
    field: 'eval_status',
    headerName: '평가상태',
    valueFormatter: (params) => { // cell 데이터 변경
      const { eval_status, improve_status } = params.data;
      let result = '평가대기';
      if(improve_status && improve_status === 30) {
        result = '개선완료';
      }
      else {
        if(eval_status && eval_status === 20) {
          result = '승인완료';
        }
      }
      return result;
    },
    flex: 1,
    //headerClass: innerStyles.headerText, 
    //cellClass: innerStyles.cellText,
    filter: true, 
  },
]

// 정기 보고서 컴포넌트
const RegularReport = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();
  
  const [commentText, setCommentText] = useState('');
  const [commentFocused, setCommentFocused] = useState(false);

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회에 필요한 조건을 상태로 관리합니다. (평가연도, 평가월)
  const [searchStatus, setSearchStatus] = useState({});
  // 데이터 조회에 필요한 쿼리스트링을 만듭니다.
  const qeuryString = { 
    params: { // 쿼리스트링 만들때 params 이름을 사용하는게 규칙입니다.
      year: searchStatus.year,
      month: searchStatus.month,
    },
  }

  // 데이터 조회 요청
  const getData = useGetTableDataInQueryString(
    "request",
    "/getMonitoringReportRegular",
    group_code,
    project_code,
    qeuryString,
  );

  // 필터링 목록 조회 요청 (평가년도별, 평가년도의 최신 평가 월)
  const getFilterListData = useGetTableData(
    "request",
    "/getMonitoringReportRegularFilterList",
    group_code,
    project_code,
  );
  // 컴포넌트를 마운트할 때 최신 평가연도, 최신월, 마지막 설비로 상태를 초기화합니다.
  useEffect(() => {
    // 데이터가 로드되지 않았거나 비어 있는 경우 처리 중단
    if(!getFilterListData.data || getFilterListData.data.length === 0 ) {
      return;
    }
    
    // 최신 평가연도 데이터 가져오기
    let latestYearData = null;
    for(let i = getFilterListData.data.length - 1; i >= 0; i--) {
      if(getFilterListData.data[i].create_year && getFilterListData.data[i].latest_month) {
        latestYearData = getFilterListData.data[i];
        break;
      }
    }
    if(!latestYearData) {
      return; // 최신 평가연도 데이터가 없으면 처리 중단
    }

    const data = 
    {
      year: latestYearData.create_year,
      month: Number(latestYearData.latest_month),
    };
    
    setSearchStatus(data);
  }, [getFilterListData.data]);

  // 다운로드 관련 변수 및 함수
  const gridRef = useRef(null); // ✅ ref 생성
  const handleExportCSV = () => {
    if(!gridRef.current) return;
    
    const now = new Date();
    const yyyy = now.getUTCFullYear();
    const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(now.getUTCDate()).padStart(2, '0');
    const utcDate = `${yyyy}${mm}${dd}`;

    gridRef.current.api.exportDataAsCsv({
      fileName: `위험성평가_정기보고서_${utcDate}.csv`, // 파일 이름 설정
    }); // ✅ CSV 다운로드
  };
  const handleExportExcel = (rowData, columnDefs, noteText='', footerText = '', year='', month='') => {
    const headers = columnDefs.map(col => col.headerName);
    const fields = columnDefs.map(col => col.field);

    const sheetData = [];

    // Title row
    sheetData.push(['위험성평가 정기 보고서']);

    // Date row (centered and merged)
    const generatedDate = `생성일자: ${new Date().toLocaleDateString()}`;
    sheetData.push([generatedDate]);

    // Search Date Row(centered and merged)
    const dataDate = `조회일자: ${year}년 ${month}월`;
    sheetData.push([dataDate]);

    // Header row
    sheetData.push(headers);

    // Data rows with valueFormatter support
    rowData.forEach(row => {
      const formattedRow = fields.map((field, index) => {
        const colDef = columnDefs[index];

        // valueFormatter가 정의되어 있으면 수동 호출
        if (typeof colDef.valueFormatter === 'function') {
            const formatted = colDef.valueFormatter({ value: row[field], data: row });
            return formatted;
        }

        // fallback to raw value
        return row[field] ?? '';
      });

      sheetData.push(formattedRow);
    });
    // Data rows
    // rowData.forEach(row => {
    //     sheetData.push(fields.map(f => row[f] ?? ''));
    // });

    // Note row
    const noteRow = new Array(headers.length).fill('');
    noteRow[0] = '비고:';
    noteRow[1] = noteText;
    sheetData.push(noteRow);

    // Footer row
    const footerRow = new Array(headers.length).fill('');
    footerRow[0] = footerText;
    sheetData.push(footerRow);

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Merges
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }, // title merge
      { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } }, // 생성일자 merge
      { s: { r: 2, c: 0 }, e: { r: 2, c: headers.length - 1 } }, // 조회일자 merge
      { s: { r: sheetData.length - 2, c: 1 }, e: { r: sheetData.length - 2, c: headers.length - 1 } }, // note
      { s: { r: sheetData.length - 1, c: 0 }, e: { r: sheetData.length - 1, c: headers.length - 1 } } // footer
    ];

    // Title style
    worksheet['A1'].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: 'center' }
    };

    // Date style (merged cell A2)
    worksheet['A2'].s = {
      alignment: { horizontal: 'left' },
      // alignment: { horizontal: 'right' },
      font: { italic: true }
    };

    // 데이터 기준일 style (merged cell A3)
    worksheet['A3'].s = {
      alignment: { horizontal: 'left' },
      // alignment: { horizontal: 'right' },
      font: { italic: true }
    };

    // Header style
    for (let c = 0; c < headers.length; c++) {
      const cell = XLSX.utils.encode_cell({ r: 3, c });
      worksheet[cell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'C0BAF8' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin', color: { rgb: '505050' } },
          bottom: { style: 'thin', color: { rgb: '505050' } },
          left: { style: 'thin', color: { rgb: '505050' } },
          right: { style: 'thin', color: { rgb: '505050' } }
        }
      };
    }

    // Body border style
    for (let r = 4; r < sheetData.length - 2; r++) {
      for (let c = 0; c < headers.length; c++) {
        const cell = XLSX.utils.encode_cell({ r, c });
        if (worksheet[cell]) {
          worksheet[cell].s = {
            border: {
              top: { style: 'thin', color: { rgb: '505050' } },
              bottom: { style: 'thin', color: { rgb: '505050' } },
              left: { style: 'thin', color: { rgb: '505050' } },
              right: { style: 'thin', color: { rgb: '505050' } }
            }
          };
        }
      }
    }

    // Note style
    const noteLabelCell = XLSX.utils.encode_cell({ r: sheetData.length - 2, c: 0 });
    const noteTextCell = XLSX.utils.encode_cell({ r: sheetData.length - 2, c: 1 });
    worksheet[noteLabelCell].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'C0BAF8' } },
      alignment: { horizontal: 'center', vertical: 'top' },
      border: {
        top: { style: 'thin', color: { rgb: '505050' } },
        bottom: { style: 'thin', color: { rgb: '505050' } },
        left: { style: 'thin', color: { rgb: '505050' } },
        right: { style: 'thin', color: { rgb: '505050' } }
      }
    };
    worksheet[noteTextCell].s = {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'left', vertical: 'top', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: '505050' } },
        bottom: { style: 'thin', color: { rgb: '505050' } },
        left: { style: 'thin', color: { rgb: '505050' } },
        right: { style: 'thin', color: { rgb: '505050' } }
      }
    };
    // 병합된 noteText 영역 전체에 border 적용
    for (let c = 2; c < headers.length; c++) {
      const cell = XLSX.utils.encode_cell({ r: sheetData.length - 2, c });
      worksheet[cell] = worksheet[cell] || {};
      worksheet[cell].s = {
        border: {
          top: { style: 'thin', color: { rgb: '505050' } },
          bottom: { style: 'thin', color: { rgb: '505050' } },
          left: { style: 'thin', color: { rgb: '505050' } },
          right: { style: 'thin', color: { rgb: '505050' } }
        }
      };
    }

    // Column widths
    worksheet['!cols'] = Array(headers.length).fill({ wch: 15 });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '위험성평가(정기보고서)');

    const xlsxBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const now = new Date();
    const yyyy = now.getUTCFullYear();
    const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(now.getUTCDate()).padStart(2, '0');
    const utcDate = `${yyyy}${mm}${dd}`;

    saveAs(new Blob([xlsxBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }), `위험성평가_정기보고서_${utcDate}.xlsx`);
  };

  // 평가연도 목록 (중복 제거를 위한 작업)
  const yearList = Array.from(
    new Set(getFilterListData.data.map(item => item.create_year))
  );

  ////////////////////////
  // 렌더링
  ////////////////////////
  return (
      <>
          {/* 정기 보고서 */}
          <Card 
              sx={{ 
                  width: '100%',
                  height: '100%',
                  //paddingBottom: '16px',
                  border: `1px solid ${theme.palette.divider}`, 
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
                  borderRadius: "0.375rem", 
                  bgcolor: 'var(--mui-palette-background-paper)',
                  //overflow: 'hidden'
              }}
          >
              {/* header 영역 */}
              <Box sx={{ display:'flex', width: '100%', height: '50px', borderBottom: `1px solid ${theme.palette.divider}`, justifyContent: 'space-between'}}>
                  {/* 조회일자 */}
                  <Box display='flex' gap={4}>
                      {/* 평가연도 선택 */}
                      <Box 
                          sx={{ 
                              display: 'flex',
                              width: 'auto',
                              height: '100%', // ⭐ 자식 요소가 부모 높이를 따라가게
                              justifyContent: 'flex-start', // ✅ 'first'가 아닌 유효한 값
                              alignItems: 'center',         // ✅ 수직 중앙 정렬
                              gap: 4, // ✅ 요소 간의 간격을 4px로 설정
                          }}
                      >
                          <Box
                              sx={{
                                  //fontFamily: FONT_PROPS.PRIMARY,
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '0 36px',
                                  backgroundColor: '#7367F029',
                                  //borderRight: `0.5px solid ${theme.palette.divider}`,
                                  fontWeight: FONT_PROPS.MEDIUM,
                                  fontSize: 15,
                                  lineHeight: FONT_PROPS.LINEHEIGHT,
                                  color: '#7367F0',
                              }}>
                              평가연도
                          </Box>
                          <FormControl size="small">
                              <Box
                                  sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  //gap: "16px",
                                  }}
                              >
                                  <Select
                                      value={searchStatus.year || ""}
                                      displayEmpty
                                      onChange={(e) => {
                                          // 평가연도 변경 시 상태 업데이트
                                          setSearchStatus({
                                              ...searchStatus,
                                              year: e.target.value,
                                          });
                                      }}
                                      sx={{
                                          minWidth: "100px",
                                          fontWeight: FONT_PROPS.SEMIBOLD,
                                          color: theme.text,
                                          fontSize: 15,
                                      }}
                                  >
                                  {yearList.reverse().map((year, index) => (
                                      <MenuItem
                                          key={index}
                                          value={year}
                                          sx={{
                                              fontWeight: FONT_PROPS.SEMIBOLD,
                                              color: theme.text,
                                              fontSize: 15,
                                          }}
                                      >
                                          {year}년
                                      </MenuItem>
                                  ))}
                                  </Select>
                              </Box>
                          </FormControl>
                      </Box>
                      {/* 평가월 선택 */}
                      <Box 
                          sx={{ 
                              display: 'flex',
                              width: 'auto',
                              height: '100%', // ⭐ 자식 요소가 부모 높이를 따라가게
                              justifyContent: 'flex-start', // ✅ 'first'가 아닌 유효한 값
                              alignItems: 'center',         // ✅ 수직 중앙 정렬
                              gap: 4, // ✅ 요소 간의 간격을 4px로 설정
                          }} 
                      >
                          <Box
                              sx={{
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '0 36px',
                                  backgroundColor: '#7367F029',
                                  fontWeight: FONT_PROPS.MEDIUM,
                                  fontSize: 15,
                                  lineHeight: FONT_PROPS.LINEHEIGHT,
                                  color: '#7367F0',
                              }}>
                              평가월
                          </Box>
                          <FormControl size="small">
                              <Box
                                  sx={{
                                      display: "flex",
                                      alignItems: "center",
                                  }}
                              >
                                  <Select
                                      value={searchStatus.month || ""}
                                      displayEmpty
                                      onChange={(e) => {
                                          // 평가월 변경 시 상태 업데이트
                                          setSearchStatus({
                                              ...searchStatus,
                                              month: e.target.value,
                                          });
                                      }}
                                      sx={{
                                          minWidth: "80px",
                                          fontWeight: FONT_PROPS.SEMIBOLD,
                                          color: theme.text,
                                          fontSize: 15,
                                      }}
                                  >
                                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reverse().map((month, index) => (
                                      <MenuItem
                                          key={index}
                                          value={month}
                                          sx={{
                                              fontWeight: FONT_PROPS.SEMIBOLD,
                                              color: theme.text,
                                              fontSize: 15,
                                          }}
                                      >
                                          {month}월
                                      </MenuItem>
                                  ))}
                                  </Select>
                              </Box>
                          </FormControl>
                      </Box>
                  </Box>
                  {/* Excel 다운로드 버튼 */}
                  <Box display='flex' alignItems='center' padding='0px 24px'>
                      <Box display="flex" justifyContent="flex-end" gap={2} sx={{ padding: '4px 0px' }}>
                          <Buttons.Custom 
                              startIcon={<DownloadIcon />} 
                              onClick={() => {
                                  //console.log("CSV 다운로드 클릭");
                                  handleExportCSV();
                              }}
                              sx={{ 
                                  border: `1px solid #B83DCD50`,
                                  bgcolor: '#B83DCD30', 
                                  color: '#B83DCD', 
                                  fontSize: 15, 
                              }}
                          >
                              CSV 다운로드
                          </Buttons.Custom>
                              <Buttons.Custom 
                                  startIcon={<DownloadIcon />} 
                                  onClick={() => {
                                      handleExportExcel(
                                          getData?.data,
                                          reportColumn,
                                          commentText,
                                          '※ 본 보고서는 시스템에서 자동 생성되었습니다.',
                                          searchStatus.year,
                                          searchStatus.month
                                      );
                                  }}
                                  sx={{ 
                                      border: `1px solid #B83DCD50`,
                                      bgcolor: '#B83DCD30', 
                                      color: '#B83DCD', 
                                      fontSize: 15, 
                                  }}
                              >
                              EXCEL 다운로드
                          </Buttons.Custom>
                      </Box>
                  </Box>
              </Box>
              {/* 테이블 영역 */}
              <Box sx={{ width: '100%', height: 'calc(100% - 100px)', overflow: 'auto' }}>
                  <div className="ag-theme-quartz-monitoring-report" style={{ height: '100%', width: '100%' }}>
                      <AgGridReact
                      ref={gridRef} // ✅ ref 등록
                      rowData={getData?.data}
                      columnDefs={reportColumn}
                      //domLayout="autoHeight"
                      pagination={true} // 페이지 네이션 사용 유무
                      //paginationPageSize={100} // 페이지 네이션 선택 사이즈
                      //paginationPageSizeSelector={[5, 10, 20, 50, 100]} // 페이지 네이션 사이즈 설정
                      //paginationPageSizeSelector={false} // ✅ 드롭다운 비활성화
                      localeText={AG_GRID_LOCALE_KR} // 한글 적용
                      />
                  </div>
              </Box>
              {/* 비고 영역 */}
              <Box sx={{ width: '100%', height: '50px', borderTop: `1px solid ${theme.palette.divider}` }}>
                  <Box 
                      sx={{ 
                          display: 'flex',
                          width: 'auto',
                          height: '100%', // ⭐ 자식 요소가 부모 높이를 따라가게
                          justifyContent: 'flex-start', // ✅ 'first'가 아닌 유효한 값
                          alignItems: 'center',         // ✅ 수직 중앙 정렬
                      }}
                  >
                      <Box
                          sx={{
                              width: '200px',
                              height: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: '#7367F029',
                              fontWeight: FONT_PROPS.MEDIUM,
                              fontSize: 15,
                              lineHeight: FONT_PROPS.LINEHEIGHT,
                              color: '#7367F0',
                          }}>
                          비고
                      </Box>
                      <ClickAwayListener onClickAway={() => setCommentFocused(false)}>
                          <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                              {/* 원래 입력창 */}
                              <TextField
                                  label="비고를 입력하세요"
                                  value={commentText}
                                  onFocus={() => setCommentFocused(true)}
                                  onChange={(e) => setCommentText(e.target.value)}
                                  variant="filled"
                                  sx={{
                                      width: '100%',
                                      height: '100%',
                                      '& .MuiFilledInput-root': {
                                          backgroundColor: '#ffffff',
                                          '&:hover': {
                                          backgroundColor: theme.palette.action.hover, // 호버 시 배경
                                          },
                                          '&.Mui-focused': {
                                          backgroundColor: '#ffffff', // 포커스 시도 흰색 유지
                                          }
                                      },
                                      '& .MuiInputLabel-root': {
                                          opacity: 0.5,
                                          transition: 'opacity 0.3s, transform 0.3s, color 0.3s',
                                      },
                                      '& .MuiInputLabel-root.Mui-focused': {
                                          opacity: 1, // 포커스 시엔 무조건 보이게
                                      },
                                  }}
                              />

                              {/* 위쪽 확장 입력창 */}
                              {commentFocused && (
                              <Paper
                                  elevation={3}
                                  sx={{
                                  position: 'absolute',
                                  left: 0,
                                  bottom: '100%',
                                  mb: 1,
                                  width: '100%',
                                  zIndex: 10,
                                  p: 2,
                                  backgroundColor: 'white',
                                  border: '1px solid #ccc',
                                  }}
                              >
                                  <TextField
                                  autoFocus
                                  multiline
                                  fullWidth
                                  minRows={4}
                                  value={commentText}
                                  onChange={(e) => setCommentText(e.target.value)}
                                  />
                              </Paper>
                              )}
                          </Box>
                      </ClickAwayListener>
                  </Box>
              </Box>
          </Card>
      </>
  );
}

/**
 * 개선실행 결과서 관련 객체 및 함수
 */

// 개선실행 결과서 컴포넌트
const StrategyReport = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회에 필요한 조건을 상태로 관리합니다. (평가연도, 평가월)
  const [searchStatus, setSearchStatus] = useState({});
  // 데이터 조회에 필요한 쿼리스트링을 만듭니다.
  const qeuryString = { 
    params: { // 쿼리스트링 만들때 params 이름을 사용하는게 규칙입니다.
      year: searchStatus.year,
      month: searchStatus.month,
      machine_id: searchStatus.machine_id,
    },
  }
  // 데이터 조회 요청
  const getData = useGetTableDataInQueryString(
    "request",
    "/getMonitoringReportStrategy",
    group_code,
    project_code,
    qeuryString,
  );

  // 필터링 목록 조회 요청 (평가년도별, 평가년도의 최신 평가 월을 가져옵니다.)
  const getFilterListData = useGetTableData(
    "request",
    "/getMonitoringReportStrategyFilterList",
    group_code,
    project_code,
  );
  // 유해위험요인등록 현황 조회 요청 (설비명을 가져옵니다.)
  const getRegisterStatusData = useGetTableData(
    "request",
    "/getRegisterStatus", 
    group_code,
    project_code
  );
  // 컴포넌트를 마운트할 때 최신 평가연도, 최신월, 마지막 설비로 상태를 초기화합니다.
  useEffect(() => {
    // 데이터가 로드되지 않았거나 비어 있는 경우 처리 중단
    if(!getFilterListData.data || getFilterListData.data.length === 0 ) {
      return;
    }
    if(!getRegisterStatusData.data || getRegisterStatusData.data.length === 0) {
      return;
    }
    
  // 최신 평가연도 데이터 가져오기
  let latestYearData = null;
  for(let i = getFilterListData.data.length - 1; i >= 0; i--) {
      if(getFilterListData.data[i].create_year &&
          getFilterListData.data[i].latest_month) {
          latestYearData = getFilterListData.data[i];
          break;
      }
  }
  if(!latestYearData) {
    return; // 최신 평가연도 데이터가 없으면 처리 중단
  }

  const data = 
  {
    year: latestYearData.create_year,
    month: Number(latestYearData.latest_month),
    machine_id: 'all', // 모든 설비를 조회하기 위해 'all'로 설정합니다.
  };
    
    setSearchStatus(data);
  }, [getFilterListData.data, getRegisterStatusData.data]);

  // 엑셀 다운로드(레거시)
  const handleExportExcel_lagacy = async (dataList) => {

      // 서버에서 이미지 배열 요청
      const fetchImageBase64List = async (filenames) => {
          const endpoint = 'getImageFile';
          const res = await axiosPrivate.post(`/risk/${group_code}/${project_code}/${endpoint}`, { filenames });
          const { images } = res.data;
          return images
                  .filter((img) => !img.error)
                  .map((img) => ({
                  filename: img.filename,
                  base64: `data:${img.mime};base64,${img.base64}`,
                  extension: img.mime.split("/")[1],
              }));
      };

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("개선 보고서");

      sheet.columns = [
          { width: 20 },
          { width: 30 },
          { width: 20 },
          { width: 30 },
      ];

      let currentRow = 1;

      for (const data of dataList) {
          const {
              process_name, // 공정명
              machine_name, // 마스터 데이터 설비명
              safe_machine_name, // 위험성 평가용 설비명
              improve_number, // 개선 NO
              emp_name, // 담당자
              standard_id, // 개선전 허용 기준
              frequency_level, // 개선전 빈도성
              importancy_level, // 개선전 강도성
              improve_after_risk, // 개선후 위험성
              danger_description, // 위험상황
              improve_plan, // 개선 내용
              comp_date, // 개선대책 완료일
              improve_before, // 개선전 사진
              improve_after, // 개선후 사진
          } = data;
            
          const imageFilenames = [improve_before.split('/').pop(), improve_after.split('/').pop()];
          const images = await fetchImageBase64List(imageFilenames);

          const merge = (range, value, bold = false, bgColor) => {
              sheet.mergeCells(range);
              const cell = sheet.getCell(range.split(":")[0]);
              cell.value = value;
              cell.alignment = { vertical: "middle", horizontal: "center" };
              if (bold) cell.font = { bold: true };
              if (bgColor) {
                  cell.fill = {
                      type: "pattern",
                      pattern: "solid",
                      fgColor: { argb: bgColor },
                  };
              }
          };

          merge(`A${currentRow}:A${currentRow + 1}`, "평가 대상명", true);
          merge(`B${currentRow}:B${currentRow + 1}`, process_name);
          merge(`C${currentRow}:C${currentRow + 1}`, "설비·구역명", true);
          merge(`D${currentRow}:D${currentRow + 1}`, safe_machine_name || machine_name);

          currentRow += 2;

          merge(`A${currentRow}:A${currentRow + 1}`, "개선 NO.", true);
          merge(`B${currentRow}:B${currentRow + 1}`, improve_number);
          merge(`C${currentRow}:C${currentRow + 1}`, "담당자", true);
          merge(`D${currentRow}:D${currentRow + 1}`, emp_name);

          currentRow += 2;

          merge(`A${currentRow}:B${currentRow}`, "개선 전", true, "FFF59D");
          merge(`C${currentRow}:D${currentRow}`, "개선 후", true, "B3E5FC");

          currentRow++;

          const beforeImg = images.find((i) => i.filename === imageFilenames[0]);
          const afterImg = images.find((i) => i.filename === imageFilenames[1]);

          if (beforeImg) {
          const id = workbook.addImage({
              base64: beforeImg.base64,
              extension: beforeImg.extension,
          });
          sheet.mergeCells(`A${currentRow}:B${currentRow + 9}`);
          sheet.addImage(id, { tl: { col: 0, row: currentRow - 1 }, ext: { width: 250, height: 180 } });
          }

          if (afterImg) {
          const id = workbook.addImage({
              base64: afterImg.base64,
              extension: afterImg.extension,
          });
          sheet.mergeCells(`C${currentRow}:D${currentRow + 9}`);
          sheet.addImage(id, { tl: { col: 2, row: currentRow - 1 }, ext: { width: 250, height: 180 } });
          }

          currentRow += 10;

          merge(`A${currentRow}:B${currentRow}`, "위험 상황", true);
          merge(`C${currentRow}:D${currentRow}`, "개선 내용", true);

          currentRow++;

          merge(`A${currentRow}:B${currentRow}`, danger_description);
          merge(`C${currentRow}:D${currentRow}`, improve_plan);

          currentRow++;

          merge(`A${currentRow}:B${currentRow}`, "개선전 위험성", true, "B2EBF2");
          merge(`C${currentRow}:D${currentRow}`, "개선후 위험성", true, "C8E6C9");

          currentRow++;

          const beforeRiskLevel = frequency_level * importancy_level;
          const level = '매우높음';

          merge(`A${currentRow}:B${currentRow}`, `${beforeRiskLevel}(${level})`);
          merge(`C${currentRow}:D${currentRow}`, improve_after_risk);

          currentRow++;

          merge(`A${currentRow}:D${currentRow}`, `개선대책 완료일: ${comp_date}`);
          sheet.getCell(`A${currentRow}`).alignment = { horizontal: "right" };
          sheet.getCell(`A${currentRow}`).font = { italic: true };

          currentRow += 3; // 다음 보고서 시작
      }

      const now = new Date();
      const yyyy = now.getUTCFullYear();
      const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(now.getUTCDate()).padStart(2, '0');
      const utcDate = `${yyyy}${mm}${dd}`;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `위험성평가_개선실행결과서_${utcDate}.xlsx`);
  };
  // 엑셀 다운로드
  const handleExportExcel = async (dataList) => {

    // 서버에서 이미지 배열 요청
    const fetchImageBase64List = async (filenames) => {
      const endpoint = 'getImageFileInBase64';
      const res = await axiosPrivate.post(`/risk/${group_code}/${project_code}/${endpoint}`, { filenames });
      const { images } = res.data;
      return images
        .filter((img) => !img.error)
        .map((img) => ({
          filename: img.filename,
          base64: `data:${img.mime};base64,${img.base64}`,
          extension: img.mime.split("/")[1],
      }));
    };

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("개선 보고서");

    sheet.columns = [
      { width: 10 }, // A
      { width: 10 }, // B
      { width: 10 }, // C
      { width: 10 }, // D
      { width: 10 }, // E

      { width: 10 }, // F
      { width: 10 }, // G
      { width: 10 }, // H
      { width: 10 }, // I
      { width: 10 }, // J
    ];

    let currentRow = 1; // 현재 row
    let boderStartRow = 1;

    for (const data of dataList) {
      const {
        process_name, // 공정명
        machine_name, // 마스터 데이터 설비명
        safe_machine_name, // 위험성 평가용 설비명
        improve_number, // 개선 NO
        emp_name, // 담당자
        standard_id, // 개선전 허용 기준
        frequency_level, // 개선전 빈도성
        importancy_level, // 개선전 강도성
        improve_after_risk, // 개선후 위험성
        danger_description, // 위험상황
        improve_plan, // 개선 내용
        comp_date, // 개선대책 완료일
        improve_before, // 개선전 사진
        improve_after, // 개선후 사진
      } = data;
            
      const imageFilenames = [improve_before.split('/').pop(), improve_after.split('/').pop()];
      // const images = await fetchImagesAsObjectURLs(imageFilenames);
      const images = await fetchImageBase64List(imageFilenames);

      const merge = (range, value, bold = false, bgColor) => {
        sheet.mergeCells(range);
        const cell = sheet.getCell(range.split(":")[0]);
        cell.value = value;
        cell.alignment = { vertical: "middle", horizontal: "center" };
        if (bold) cell.font = { bold: true };
        if (bgColor) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
        }
      };
          
      merge(`A${currentRow}:B${currentRow + 1}`, "평가 대상명", true); // A ~ B
      merge(`C${currentRow}:E${currentRow + 1}`, process_name); // C ~ E
      merge(`F${currentRow}:G${currentRow + 1}`, "설비·구역명", true); // F ~ G
      merge(`H${currentRow}:J${currentRow + 1}`, safe_machine_name || machine_name); // H ~ J

      currentRow += 2;

      merge(`A${currentRow}:B${currentRow + 1}`, "개선 NO.", true);
      merge(`C${currentRow}:E${currentRow + 1}`, improve_number);
      merge(`F${currentRow}:G${currentRow + 1}`, "담당자", true);
      merge(`H${currentRow}:J${currentRow + 1}`, emp_name);

      currentRow += 2;

      merge(`A${currentRow}:E${currentRow}`, "개선 전", true, "FFF59D"); // A ~ E
      merge(`F${currentRow}:J${currentRow}`, "개선 후", true, "B3E5FC"); // F ~ J

      currentRow++;

      // 이미지 센터 맞추기
      const centerImageInMergedCell = (sheet, imageData, startCol, startRow, imageWidth, imageHeight) => {
        const imageId = sheet.workbook.addImage({
          base64: imageData.base64,
          extension: imageData.extension,
        });

        sheet.addImage(imageId, {
          tl: {
            col: startCol,
            row: startRow,
          },
          ext: {
            width: imageWidth,
            height: imageHeight,
          },
        });
      };

      const beforeImg = images.find((i) => i.filename === imageFilenames[0]);
      const afterImg = images.find((i) => i.filename === imageFilenames[1]);

      sheet.mergeCells(`A${currentRow}:E${currentRow + 9}`);
      sheet.mergeCells(`F${currentRow}:J${currentRow + 9}`);

      if (beforeImg) {
        centerImageInMergedCell(sheet, beforeImg, 1, currentRow, 250, 180);
      }

      if (afterImg) {
        centerImageInMergedCell(sheet, afterImg, 6, currentRow, 250, 180);
      }

      currentRow += 10;

      merge(`A${currentRow}:B${currentRow}`, "위험 상황", true);
      merge(`C${currentRow}:E${currentRow}`, danger_description);
      merge(`F${currentRow}:G${currentRow}`, "개선 내용", true);
      merge(`H${currentRow}:J${currentRow}`, improve_plan);

      currentRow++;

      const riskLevel = (level) => {
        switch(level) {
          case 1: return '매우낮음';
          case 2: return '낮음';  
          case 3: return '보통';  
          case 4: return '약간높음';
          case 5: return '높음';  
          case 6: return '매우높음';  
          default: return '알수없음'; 
        }
      };

      merge(`A${currentRow}:B${currentRow}`, "개선전 위험성", true, "FFF59D");
      merge(`C${currentRow}:E${currentRow}`, `${frequency_level * importancy_level}(${riskLevel(standard_id)})`);

      merge(`F${currentRow}:G${currentRow}`, "개선후 위험성", true, "B3E5FC");
      merge(`H${currentRow}:J${currentRow}`, riskLevel(improve_after_risk));

      currentRow++;

      merge(`A${currentRow}:J${currentRow}`, `개선대책 완료일: ${comp_date}`); // A ~ J
      sheet.getCell(`A${currentRow}`).alignment = { vertical: "middle", horizontal: "center" };
      sheet.getCell(`A${currentRow}`).font = { bold: false };
      sheet.getRow(currentRow).height = 40;

      const setOuterBorderOnly = (sheet, startCol, endCol, startRow, endRow, style = 'dashed') => {
        for (let row = startRow; row <= endRow; row++) {
          for (let col = startCol; col <= endCol; col++) {
            const cell = sheet.getCell(row, col);
            cell.border = {};

            // 윗줄
            if (row === startRow) {
              cell.border.top = { style, color: { argb: 'FF999999' } };
            }
            // 아랫줄
            if (row === endRow) {
              cell.border.bottom = { style, color: { argb: 'FF999999' } };
            }
            // 왼쪽
            if (col === startCol) {
              cell.border.left = { style, color: { argb: 'FF999999' } };
            }
            // 오른쪽
            if (col === endCol) {
              cell.border.right = { style, color: { argb: 'FF999999' } };
            }
          }
        }
      };

      // 바깥 테두리 적용
      setOuterBorderOnly(sheet, 1, 10, boderStartRow, currentRow); // A~J, startRow ~ endRow

      currentRow += 3; // 다음 보고서 시작
      boderStartRow = currentRow + 1;
    }

    const now = new Date();
    const yyyy = now.getUTCFullYear();
    const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(now.getUTCDate()).padStart(2, '0');
    const utcDate = `${yyyy}${mm}${dd}`;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `위험성평가_개선실행결과서_${utcDate}.xlsx`);
  };

  // 평가연도 목록 (중복 제거를 위한 작업)
  const yearList = Array.from(
    new Set(getFilterListData.data.map(item => item.create_year))
  );
  // 설비명 목록 (중복 제거를 위한 작업)
  const machineIdList = Array.from(
    new Map(
      getRegisterStatusData.data.map((item) => [
        item.machine_id, 
        { 
          machine_id: item.machine_id, 
          machine_name: item.machine_name 
        }
      ])
    ).values()
  );
  machineIdList.unshift({ machine_id: 'all', machine_name: '전체' }); // 전체 추가

  ////////////////////////
  // 렌더링
  ////////////////////////
  return (
    <Card sx={{ width: '100%', height: '100%', boxShadow: '0px 1px 4px rgba(0,0,0,0.07)', border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", bgcolor: 'var(--mui-palette-background-paper)' }}>
      {/* header 영역 */}
      <Box sx={{ display:'flex', width: '100%', height: '50px', borderBottom: `1px solid ${theme.palette.divider}`, justifyContent: 'space-between',}}>
        {/* 조회일자 */}
        <Box display='flex' gap={4}>
          {/* 평가연도 선택 */}
          <Box sx={{ display: 'flex', width: 'auto', height: '100%', justifyContent: 'flex-start', alignItems: 'center', gap: 4 }}>
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', padding: '0 36px', backgroundColor: '#7367F029', fontWeight: FONT_PROPS.MEDIUM, fontSize: 15, lineHeight: FONT_PROPS.LINEHEIGHT, color: '#7367F0' }}>
              평가연도
            </Box>
            <FormControl size="small">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Select
                  value={searchStatus.year || ""}
                  displayEmpty
                  onChange={(e) => {
                    // 평가연도 변경 시 상태 업데이트
                    setSearchStatus({
                      ...searchStatus,
                      year: e.target.value,
                    });
                  }}
                sx={{ minWidth: "100px", fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                >
                {yearList.reverse().map((year, index) => (
                  <MenuItem
                    key={index}
                    value={year}
                    sx={{ fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                  >
                    {year}년
                  </MenuItem>
                ))}
                </Select>
              </Box>
            </FormControl>
          </Box>
          {/* 평가월 선택 */}
          <Box sx={{ display: 'flex', width: 'auto', height: '100%', justifyContent: 'flex-start', alignItems: 'center', gap: 4 }}>
            <Box sx={{ height: '100%', display: 'flex',alignItems: 'center', padding: '0 36px', backgroundColor: '#7367F029', fontWeight: FONT_PROPS.MEDIUM, fontSize: 15, lineHeight: FONT_PROPS.LINEHEIGHT, color: '#7367F0' }}>
              평가월
            </Box>
            <FormControl size="small">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Select
                  value={searchStatus.month || ""}
                  displayEmpty
                  onChange={(e) => {
                    // 평가월 변경 시 상태 업데이트
                    setSearchStatus({
                        ...searchStatus,
                        month: e.target.value,
                    });
                  }}
                  sx={{ minWidth: "80px", fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reverse().map((month, index) => (
                    <MenuItem
                      key={index}
                      value={month}
                      sx={{ fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                    >
                      {month}월
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </FormControl>
          </Box>
          {/* 설비명 선택 */}
          <Box sx={{ display: 'flex', width: 'auto', height: '100%',  justifyContent: 'flex-start', alignItems: 'center', gap: 4 }}>
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', padding: '0 36px', backgroundColor: '#7367F029', fontWeight: FONT_PROPS.MEDIUM, fontSize: 15, lineHeight: FONT_PROPS.LINEHEIGHT, color: '#7367F0', }}>
              설비·구역명
            </Box>
            <FormControl size="small">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Select
                  value={searchStatus.machine_id || ""}
                  displayEmpty
                  onChange={(e) => {
                    // 평가월 변경 시 상태 업데이트
                    setSearchStatus({
                      ...searchStatus,
                      machine_id: e.target.value,
                    });
                  }}
                  sx={{ minWidth: "120px", fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                >
                  {machineIdList.map((data, index) => {
                    return (
                      <MenuItem
                        key={index}
                        value={data.machine_id}
                        sx={{ fontWeight: FONT_PROPS.SEMIBOLD, color: theme.text, fontSize: 15 }}
                      >
                        {data.machine_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Box>
            </FormControl>
          </Box>
        </Box>

        {/* Excel 다운로드 버튼 */}
        <Box display='flex' alignItems='center' padding='0px 24px'>
          <Box display="flex" justifyContent="flex-end" gap={2} sx={{ padding: '4px 0px' }}>
            <Buttons.Custom 
              startIcon={<DownloadIcon />} 
              onClick={() => {
                //console.log("excel 다운로드 클릭");
                handleExportExcel([...getData.data]);
              }}
              sx={{ border: `1px solid #B83DCD50`, bgcolor: '#B83DCD30', color: '#B83DCD', fontSize: 15 }}
            >
              EXCEL 다운로드
            </Buttons.Custom>
          </Box>
        </Box>
      </Box>
      {/* 보고서 영역 */}
      <Box sx={{ width: '100%', height: 'calc(100% - 50px)', overflow: 'auto' }}>
        <Grid container spacing={2} padding='12px 24px'>
          {getData.data.map(item => (
            <Grid item xs={12} sm={6} md={6} key={item.improve_id}>
              <CollapsibleCardTemplate 
                title={item.safe_machine_name || item.machine_name}
                isInitialOpen={true}
                containerSX={{ mb: 0 }}
                titleSX={{ fontSize: 15, padding: '8px 24px' }}
                // contentSX={{ 
                //     padding: 0,
                //     paddingBottom: '0px !important',
                // }}
              >
                <StrategyReportTemplate data={item}/>
              </CollapsibleCardTemplate>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Card>
  );
};

// 개선실행 결과서 Template
const StrategyReportTemplate = ({ data }) => {
  const theme = useTheme();

  const CustomTitleTableCell = ({ children, sx = {}, ...props }) => (
    <TableCell
      sx={{
        width: '15%',
        textAlign: 'center',
        borderRight: `1px solid ${theme.palette.divider}`,
        fontWeight: FONT_PROPS.SEMIBOLD,
        fontSize: 13,
        ...sx, // 개별 오버라이드 가능
      }}
      {...props}
    >
      {children}
    </TableCell>
  );
  const CustomTableCell = ({ children, sx = {}, ...props }) => (
    <TableCell
      sx={{
        width: '35%',
        textAlign: 'center',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        borderRight: `1px solid ${theme.palette.divider}`,
        fontWeight: FONT_PROPS.MEDIUM,
        fontSize: 13,
        ...sx, // 개별 오버라이드 가능
      }}
      {...props}
    >
      {children}
    </TableCell>
  );

  const riskLevel = (level) => {
    let result = '';
    switch(level) {
      case 1: result = '매우낮음'; break;
      case 2: result = '낮음'; break;
      case 3: result = '보통'; break;
      case 4: result = '약간높음'; break;
      case 5: result = '높음'; break;
      case 6: result = '매우높음'; break;
      default:
      break;
    }
    return result;
  };

  // 렌더링
  return (
    <MuiTableContainer component={Paper} sx={{ width: 'fit-content' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%', border: `1px solid ${theme.palette.divider}` }}>
        <tbody>
          {/* 1행: 공정명, 설비명 */}
          <TableRow>
            <CustomTitleTableCell>평가 대상명</CustomTitleTableCell>
            <CustomTableCell>{data.process_name}</CustomTableCell>
            <CustomTitleTableCell>설비·구역명</CustomTitleTableCell>
            <CustomTableCell>{data.safe_machine_name || data.machine_name}</CustomTableCell>
          </TableRow>

          {/* 2행: 개선 NO, 담당자 */}
          <TableRow>
            <CustomTitleTableCell>개선 NO.</CustomTitleTableCell>
            <CustomTableCell>{data.improve_number}</CustomTableCell>
            <CustomTitleTableCell>담당자</CustomTitleTableCell>
            <CustomTableCell>{data.emp_name}</CustomTableCell>
          </TableRow>

          {/* 3행: 개선 전/후 제목 (컬럼 병합 + 배경색) */}
          <TableRow>
            <CustomTitleTableCell colSpan={2} sx={{ bgcolor: '#ffff99' }}>
              개선 전
            </CustomTitleTableCell>
            <CustomTitleTableCell colSpan={2} sx={{ bgcolor: '#ccf2ff' }}>
              개선 후
            </CustomTitleTableCell>
          </TableRow>

          {/* 4행: 개선 전.후 이미지 자리 */}
          <TableRow>
            <CustomTitleTableCell colSpan={2} sx={{ height: '100px' }}>
              <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                <img 
                  src={data.improve_before || null}
                  alt="개선전 사진"
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '150px',
                    maxHeight: '150px',
                    objectFit: 'fill',
                    display: 'block',
                  }}
                />
              </Box>
            </CustomTitleTableCell>
            <CustomTitleTableCell colSpan={2} sx={{ height: '100px' }}>
                <Box sx={{ width: '100%', height: '100%', display: 'flex',alignItems: 'center', justifyContent: 'center', }}>
                  <img 
                    src={data.improve_after || null}
                    alt="개선후 사진"
                    style={{
                      width: '100%',
                      height: '100%',
                      maxWidth: '150px',
                      maxHeight: '150px',
                      objectFit: 'fill',
                      display: 'block',
                    }}
                  />
                </Box>
            </CustomTitleTableCell>
          </TableRow>

          {/* 5행: 위험 상황, 개선 내용 */}
          <TableRow>
            <CustomTitleTableCell>위험 상황</CustomTitleTableCell>
            <CustomTableCell>{data.danger_description}</CustomTableCell>
            <CustomTitleTableCell>개선 내용</CustomTitleTableCell>
            <CustomTableCell>{data.improve_plan}</CustomTableCell>
          </TableRow>

          {/* 6행: 개선 전 위험성, 개선 후 위험성 */}
          <TableRow>
            <CustomTitleTableCell sx={{ bgcolor: '#ffff99' }}>개선전 위험성</CustomTitleTableCell>
            <CustomTableCell>
              {data.frequency_level * data.importancy_level}({riskLevel(data.standard_id)})
            </CustomTableCell>
            <CustomTitleTableCell sx={{ bgcolor: '#ccf2ff' }}>개선후 위험성</CustomTitleTableCell>
            <CustomTableCell>
              {riskLevel(data.improve_after_risk)}
            </CustomTableCell>
          </TableRow>

          {/* 7행: 조치완료일 */}
          <TableRow>
            <CustomTableCell colSpan={4}>
              개선대책 완료일: {data.comp_date}
            </CustomTableCell>
          </TableRow>
        </tbody>
      </Table>
    </MuiTableContainer>
  );
}
